<template>
  <div>
    <!-- Button trigger modal -->
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#showallSubjectsModal"
      @click="fetchSubjects"
    >
      Show Subjects
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="showallSubjectsModal"
      tabindex="-1"
      aria-labelledby="showallSubjectsModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="showallSubjectsModalLabel">All Subjects</h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="subjects.length">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Subject Name</th>
                    <th>Subject Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(subject, index) in subjects" :key="subject.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ subject.name }}</td>
                    <td>{{ subject.subject_price }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>No subjects found.</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      subjects: [],
    };
  },
  methods: {
    async fetchSubjects() {
      try {
        const response = await axios.get('/get-all-subjects');
        this.subjects = response.data;
      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    },
  },
};
</script>

<style scoped>
.modal-lg {
  max-width: 800px;
}
</style>
